import React from 'react';
import {useNavigate} from "react-router-dom";
import '../Login/Login.scss';
import './Error404.scss';

const Error404: React.FunctionComponent = () => {
    const navigate = useNavigate();

    return (
        <div className="loginPage">
            <div className="loginBg"/>

            <div className="loginCenter">
                <div className="loginMobileLogo">
                    <img src={`${process.env.PUBLIC_URL}/logo_fc.svg`} alt="freeCompta" className="loginMobileIcon"/>
                    <h1 className="loginMobileTitle">Free Compta</h1>
                </div>

                <div className="loginCard">
                    <div className="loginCardHeader">
                        <img src={`${process.env.PUBLIC_URL}/logo_fc.svg`} alt="freeCompta" className="loginCardLogoImg"/>
                        <div className="loginCardLogo">
                            <span className="loginCardLogoText">Free Compta</span>
                        </div>
                    </div>

                    <div className="e404CodeBlock">
                        <span className="material-symbols-outlined e404Icon">error</span>
                        <div className="e404Code">404</div>
                    </div>

                    <h2 className="loginCardTitle">Page introuvable</h2>
                    <p className="loginCardSubtitle">
                        La page que vous cherchez n'existe pas ou a été déplacée.
                    </p>

                    <div className="loginForm">
                        <button type="button" className="loginBtn" onClick={() => navigate("/")}>
                            <span className="material-symbols-outlined">arrow_back</span>
                            Retour à l'accueil
                        </button>
                    </div>
                </div>
            </div>

            <footer className="loginFooter">
                <a href="mailto:admin@free-compta.fr" className="loginFooterLink">Besoin d'aide ?</a>
                <span className="loginFooterDot">•</span>
                <span>Confidentialité</span>
                <span className="loginFooterDot">•</span>
                <span>© {new Date().getFullYear()} FREECOMPTA.</span>
            </footer>
        </div>
    );
};

export default Error404;
